<template>
  <div class="cbs-flow-view-container">
    <div class="d-flex">
      <!-- 左侧项目筛选树 -->
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <!-- 右侧主内容区 -->
      <div class="d-flex-right">
        <!-- 筛选条件区域 -->
        <el-card class="filter-card">
          <el-form :inline="true" size="small">
            <el-form-item label="当前项目">
              <span style="font-weight: bold; color: #409eff;">{{ selectProject.house_name || '请选择项目' }}</span>
            </el-form-item>

            <el-form-item label="查询时间">
              <el-date-picker
                v-model="flow_filter.timeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 240px;">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="银行账号">
              <el-input v-model="flow_filter.account_no" placeholder="请输入银行账号" clearable style="width: 200px;"></el-input>
            </el-form-item>

            <el-form-item label="银行类型">
              <el-select v-model="flow_filter.bank_type" placeholder="请选择" clearable style="width: 150px;">
                <el-option
                  v-for="item in bankTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="searchList" :loading="loading" :disabled="!selectProject.pindex_id">查询</el-button>
              <el-button @click="resetFilter" :disabled="!selectProject.pindex_id">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 同步操作区 -->
        <el-card class="sync-card" v-if="selectProject.pindex_id">
          <el-divider content-position="left">同步操作区</el-divider>
          <el-form :inline="true" size="small" style="margin-bottom: 15px;">
            <el-form-item label="同步日期">
              <el-date-picker
                v-model="sync_date_range"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 240px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="syncCbsFlow" :loading="syncing">同步数据</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 未选择项目时的提示 -->
        <el-card class="table-card" v-if="!selectProject.pindex_id">
          <div class="empty-tip">
            <i class="el-icon-info"></i>
            <span>请在左侧选择项目后再查看数据</span>
          </div>
        </el-card>

        <!-- 数据表格区域 -->
        <el-card class="table-card" v-else>
          <el-table
            :data="tableData"
            border
            stripe
            v-loading="loading"
            height="calc(100vh - 410px)"
            style="width: 100%">
            <el-table-column prop="transaction_date" label="交易时间" width="160"></el-table-column>
            <el-table-column prop="account_no" label="银行账号" width="180"></el-table-column>
            <el-table-column prop="opposite_name" label="对方户名" width="150"></el-table-column>
            <el-table-column prop="digest" label="摘要" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="发生额" width="120" align="right">
              <template slot-scope="scope">{{ scope.row.incurred_amount }}</template>
            </el-table-column>
            <el-table-column label="已勾兑" width="120" align="right">
              <template slot-scope="scope">
                <span
                  v-if="parseFloat(scope.row.reconciled_amount) > 0"
                  style="color: #409eff; cursor: pointer; text-decoration: underline;"
                  @click="viewRelatedOrders(scope.row)">
                  {{ scope.row.reconciled_amount }}
                </span>
                <span v-else>{{ scope.row.reconciled_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="可用金额" width="120" align="right">
              <template slot-scope="scope">
                <span style="color: #67c23a; font-weight: bold;">
                  {{ (parseFloat(scope.row.incurred_amount) - parseFloat(scope.row.reconciled_amount)).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="bank_serial_number" label="银行流水" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="transaction_serial_number" label="交易流水" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="证明说明" width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.prove_remark" style="color: #67c23a;">{{ scope.row.prove_remark }}</span>
                <span v-else style="color: #ccc;">-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" fixed="right" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="viewFlowDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="pagination.page"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            layout="total, prev, pager, next, jumper"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </div>
    </div>

    <!-- 流水详情弹框 -->
    <cbs-flow-detail
      :visible.sync="flowDetailVisible"
      :flow-data="currentFlowRow"
      @close="flowDetailVisible = false">
    </cbs-flow-detail>

    <!-- 关联订单弹框 -->
    <el-dialog
      title="关联订单详情"
      :visible.sync="relatedOrdersVisible"
      width="900px"
      @close="relatedOrdersVisible = false">
      <el-card class="detail-section" shadow="never">
        <el-table
          :data="relatedOrders"
          border
          size="small"
          style="width: 100%"
          max-height="400"
          v-loading="relatedOrdersLoading">
          <el-table-column label="项目名称" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.pindex_info ? scope.row.pindex_info.name : scope.row.pindex_name }}
            </template>
          </el-table-column>
          <el-table-column label="订单类型" width="120">
            <template slot-scope="scope">
                <div v-if="scope.row.order_type == 'order'" style="color: #67c23a;">应收款订单</div>
                <div v-else-if="scope.row.order_type == 'temporary'" style="color: #67c23a;">临时收费</div>
                <div v-else-if="scope.row.order_type == 'desposit'" style="color: #67c23a;">押金</div>
                <div v-else-if="scope.row.order_type == 'advance'" style="color: #67c23a;">预收款</div>
                <div v-else style="color: #f56c6c;">未匹配: {{ scope.row.order_type || 'undefined' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="h_name_date" label="房产地址" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="charge" label="应收金额" width="80" align="right"></el-table-column>
          <el-table-column prop="bill_no" label="票据号" width="120" align="right"></el-table-column>
          <el-table-column prop="charge_money" label="实收金额" width="120" align="right"></el-table-column>
          <el-table-column prop="charge_sum" label="本期欠费" width="120" align="right"></el-table-column>
          <el-table-column prop="discount" label="减免" width="100" align="right"></el-table-column>
          <el-table-column prop="delayDiscount" label="滞纳金减免" width="120" align="right"></el-table-column>
          <el-table-column prop="charge_item_name" label="费项名称" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="startDate" label="开始日期" width="120"></el-table-column>
          <el-table-column prop="endDate" label="结束日期" width="120"></el-table-column>
        </el-table>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import CbsFlowDetail from './order/CbsFlowDetail.vue';

export default {
  name: 'CbsFlowView',
  components: {
    CbsFlowDetail,
    'erp-tree': () => import('@/components/Admin/Common/erp-tree.vue')
  },
  data() {
    return {
      // 选中的项目
      selectProject: {
        pindex_id: 0,
        house_name: ''
      },

      // 筛选条件
      flow_filter: {
        timeRange: [],
        account_no: '',
        bank_type: ''
      },

      // 银行类型选项
      bankTypeOptions: [],

      // 同步
      sync_date_range: [],
      syncing: false,

      // 表格数据
      tableData: [],
      loading: false,

      // 分页
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },

      // 流水详情弹框
      flowDetailVisible: false,
      currentFlowRow: null,

      // 关联订单弹框
      relatedOrdersVisible: false,
      relatedOrders: [],
      relatedOrdersLoading: false
    };
  },

  watch: {
    bankTypeOptions: {
      handler() {},
      immediate: true
    }
  },

  methods: {
    // 点击树节点
    nodeClick(data) {
      if (data.tree && data.tree.length > 0) {
        let treeData = data.tree[data.tree.length - 1];
        if (treeData.type === 'project') {
          this.selectProject.pindex_id = treeData.pindex_id;
          this.selectProject.house_name = treeData.name;
          // 选择项目后自动查询
          this.pagination.page = 1;
          this.resetFilter();
          this.loadBankTypeList();
          this.searchList();
        }
      }
    },

    // 加载银行类型列表
    loadBankTypeList() {
      if (this.bankTypeOptions.length > 0) return;
      this.$myhttp.post('admin/cbsBankType', {}, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        if (res.data.code === 200) {
          this.bankTypeOptions = res.data.data || [];
        }
      }).catch(err => {
        console.error('加载银行类型列表异常:', err);
      });
    },

    // 查询流水列表
    searchList() {
      if (!this.selectProject.pindex_id) {
        this.$message.warning('请先在左侧选择项目');
        return;
      }

      this.loading = true;

      let startDate = undefined;
      let endDate = undefined;
      if (this.flow_filter.timeRange && this.flow_filter.timeRange.length === 2) {
        startDate = this.flow_filter.timeRange[0] + ' 00:00:00';
        endDate = this.flow_filter.timeRange[1] + ' 23:59:59';
      }

      const params = {
        pindex_id: this.selectProject.pindex_id,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        account_no: this.flow_filter.account_no || undefined,
        bank_type: this.flow_filter.bank_type || undefined,
        start_date: startDate,
        end_date: endDate
      };

      this.$myhttp.post('admin/cbs/getAvailableFlowList', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.loading = false;
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.pagination.total = res.data.data.total || 0;

          if (this.tableData.length === 0) {
            this.$message.info('暂无数据');
          }
        } else {
          this.$message.error(res.data.message || '查询失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 同步CBS流水
    syncCbsFlow() {
      if (!this.sync_date_range || this.sync_date_range.length !== 2) {
        this.$message.warning('请选择同步日期范围');
        return;
      }

      this.syncing = true;
      const params = {
        start_date: this.sync_date_range[0],
        end_date: this.sync_date_range[1],
        pindex_id: this.selectProject.pindex_id
      };

      this.$myhttp.post('admin/cbs/syncFlowByDate', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.syncing = false;
        if (res.data.code === 200) {
          this.$message.success(res.data.message || '同步成功');
          this.searchList();
        } else {
          this.$message.error(res.data.message || '同步失败');
        }
      }).catch(err => {
        this.syncing = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    },

    // 重置筛选条件
    resetFilter() {
      this.flow_filter.timeRange = [];
      this.flow_filter.account_no = '';
      this.flow_filter.bank_type = '';
      this.pagination.page = 1;
    },

    // 分页切换
    handlePageChange(page) {
      this.pagination.page = page;
      this.searchList();
    },

    // 查看流水详情
    viewFlowDetail(row) {
      this.currentFlowRow = row;
      this.flowDetailVisible = true;
    },

    // 查看关联订单
    viewRelatedOrders(row) {
      if (!row.id) {
        this.$message.warning('流水ID不存在');
        return;
      }

      this.relatedOrdersLoading = true;
      this.relatedOrdersVisible = true;

      const params = {
        flow_id: row.id
      };

      this.$myhttp.post('admin/cbs/getFlowRelatedOrders', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        this.relatedOrdersLoading = false;
        if (res.data.code === 200) {
          this.relatedOrders = res.data.data || [];
        } else {
          this.$message.error(res.data.message || '查询失败');
        }
      }).catch(err => {
        this.relatedOrdersLoading = false;
        this.$message.error('请求异常');
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.cbs-flow-view-container {
  padding: 20px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  width: 250px;
  min-height: calc(100vh - 140px);
}

.d-flex-right {
  flex: 1;
  overflow-x: hidden;
}

.filter-card {
  margin-bottom: 20px;
}

.sync-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: calc(100vh - 320px);
}

.empty-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #909399;
  font-size: 16px;
}

.empty-tip i {
  margin-right: 8px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/CbsFlowView.vue